// extracted by mini-css-extract-plugin
module.exports = {"Chat":"Chat_Chat__3pVSL","Message":"Chat_Message__2aCXH","layout":"Chat_layout__27meX","Provider":"Chat_Provider__1kIhW","Provider__active":"Chat_Provider__active__1b7MA"};